// colorizable parts
export const ROOF = 'roof';
export const WALLS = 'walls';
export const PROFILE = 'profile';
export const DOORS = 'doors';
export const GATES = 'gates';
export const WINDOWS = 'windows';
